import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {Cookie} from 'src/app/model/cookie.model';
import {Mask} from 'src/app/model/mask.model';
import {GoogleAnalyticsService} from 'src/app/services/google-analytics.service';
import {NotificationsService} from 'angular2-notifications';
import {RecaptchaComponent} from 'ng-recaptcha';
import {first} from 'rxjs/operators';
import {ConfigurationService} from 'src/app/services/configuration.service';
import {UsuarioService} from 'src/app/services/usuario.service';
import {CustomSiteService} from '../../services/customsite.service';

@Component({
    selector: 'app-login-empresa',
    templateUrl: './login-empresa.component.html',
    styleUrls: ['./login-empresa.component.css']
})
export class LoginEmpresaComponent implements OnInit {
    @ViewChild('rc', { static: true }) rc: RecaptchaComponent;
    model: any = {};
    reCaptchaKey: string;
    features: any = { loginEmpresa: false, login: [ "docs", "email" ], signUp: true };
    captchaToken: string = '';
    showSpinner: boolean = false;
    agenciaSelecionada: Number;
  pageTitle = "Atendimento - Pagmob";

    public cnpjmask = Mask.cnpj;

    constructor(private router: Router,
        private usuarioService: UsuarioService,
        private _notificationService: NotificationsService,
        public googleAnalyticsService: GoogleAnalyticsService,
        private configService: ConfigurationService, private customSiteService: CustomSiteService) {
            this.onConfigLoad = this.onConfigLoad.bind( this );
            configService.loadConfigurations().subscribe( this.onConfigLoad );
        }

        ngOnInit() {
            this.googleAnalyticsService.eventEmitter("login-empresa", "load", "page-load", 1);
            localStorage.removeItem('cookie');
            localStorage.removeItem('usuario');

            RecaptchaComponent.prototype.ngOnDestroy = function() {
                if (this.subscription) {
                    this.subscription.unsubscribe();
                }
            }
        }

        efetuarLogin() {
            if (!this.model.token || this.model.token === '') {
                this.rc.reset();
                this._notificationService.error('Login', "Selecione a opção 'Não sou um robô' ante de realizar o login.");
                return;
            }

            this.model.agencyId = this.agenciaSelecionada;

            this.showSpinner = true;
            if (this.model.cpf) {
                this.model.cpf =  this.model.cpf.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
                this.model.cpf =  this.model.cpf.replace('-', '').replace('/','').replace('-','');
            }

            this.googleAnalyticsService.eventEmitter("login-empresa", "button-click", "tentativa-login", 2);
            this.usuarioService.auth(this.model).subscribe(authResult => {
                this.usuarioService.efetuarLogin(this.model, authResult).pipe(first()).subscribe(resUsuario => {
                    this.usuarioService.getToken(this.model.agencyId).subscribe((resCookie: Cookie) => {
                        if( !resCookie ) {
                            this.showSpinner = false;//prevent from loading forever
                            throw "Something wrong is not right with cookies!";
                        }
                        this.googleAnalyticsService.eventEmitter("login-empresa", "button-click", "sucesso", 3);
                        localStorage.setItem('cookie', JSON.stringify(resCookie.cookie));

                        resUsuario.senha = '';
                        localStorage.setItem('usuario', JSON.stringify(resUsuario));
                        this.router.navigate(['app/dashboard']);
                    }, (err) => { this.showSpinner = false; });
                }, (err) => { this.showSpinner = false; this.googleAnalyticsService.eventEmitter("login-empresa", "button-click", "erro", 4); this.rc.reset(); });
            }, (err) => { this.showSpinner = false; });
        }


        verificarEmail() {
            if (this.model.cpf) {
                return false;
            } else {
                return true;
            }
        }

        verificarCNPJ() {
            if (this.model.email) {
                return false;
            } else {
                return true;
            }
        }

        resolved(captchaResponse: string) {
            this.model.token = captchaResponse;
            this.captchaToken = captchaResponse;
        }

        onConfigLoad( config ) {
            this.reCaptchaKey = config.reCaptchaKey;
            this.agenciaSelecionada = config.agencyId;
            if ( config.features ) {
                this.features = config.features;
            }
          const pageTitle = sessionStorage.getItem("pageTitle");
          if(pageTitle == null)
              this.customSiteService.login(config.agencyId).subscribe(customsite => {
                if(customsite.pageTitle) {
                  this.pageTitle = customsite.pageTitle;
                  sessionStorage.setItem("pageTitle",this.pageTitle);
                }
                if(customsite.pageTitle) sessionStorage.setItem("loginText", customsite.loginText);
                if(customsite.loginObs) sessionStorage.setItem("loginObs", customsite.loginObs);
                if(customsite.popUp) sessionStorage.setItem("popUp", customsite.popUp);
                if(customsite.privacy) sessionStorage.setItem("privacy", customsite.privacy);
                if(customsite.termsAcceptance) sessionStorage.setItem("termsAcceptance", customsite.termsAcceptance);
                if(customsite.register) sessionStorage.setItem("register", customsite.register);
              });
          else {
            this.pageTitle = pageTitle;
          }
        }
    }
